import { Link } from "@remix-run/react";
import { buttonClasses } from "./Button";
import type { ButtonClassesProps } from "./Button";

export default function LinkButton(
  props: {
    children: React.ReactNode;
    to: string;
    target?: "_blank" | "_top";
    external?: boolean;
    download?: boolean;
    reloadDocument?: boolean;
    onClick?: () => void;
    rel?: ("noopener" | "noreferrer")[];
  } & ButtonClassesProps,
) {
  const { rel, disabled, external, children, to, target, onClick } = props;

  if (disabled) {
    return <div className={buttonClasses(props)}>{children}</div>;
  }

  if (external) {
    return (
      <a
        target={target}
        href={to}
        className={buttonClasses(props)}
        download={props.download}
        onClick={onClick}
        rel={rel?.join(" ")}
      >
        {children}
      </a>
    );
  }

  return (
    <Link
      target={target}
      to={to}
      className={buttonClasses(props)}
      download={props.download}
      reloadDocument={props.reloadDocument}
      onClick={onClick}
      rel={rel?.join(" ")}
    >
      {children}
    </Link>
  );
}
